module.exports = __webpack_public_path__ + "img/Corp-transfers-banner-scaled.0ee392dc.jpg";